<ngx-loading [show]="isLoading" [config]="loaderService.loadingConfig"></ngx-loading>
<router-outlet></router-outlet>
